import { MobileNavigationProps, MobileTab } from "./MobileNavigation.contract";
import { Button } from "../../ui/Button";

export function MobileNavigation({ activeTab, onTabChange }: MobileNavigationProps) {
  const tabs: { id: MobileTab; label: string; icon: string }[] = [
    { id: "home", label: "Workspace", icon: "🏠" },
    { id: "lifecycle", label: "Workflow", icon: "🔄" },
    { id: "story", label: "Story", icon: "📖" },
    { id: "admin", label: "Admin", icon: "⚙️" },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 h-16 bg-brand-surface-soft backdrop-blur-md border-t border-black/10 flex justify-around items-center px-4 z-50 md:hidden"
      aria-label="Mobile navigation"
    >
      {tabs.map((tab) => (
        <Button
          key={tab.id}
          variant="ghost"
          size="sm"
          className={`flex h-full flex-1 flex-col items-center justify-center gap-1 rounded-xl px-2 py-2 ${activeTab === tab.id ? "bg-brand-highlight/40 text-brand-accent" : "text-brand-muted hover:text-brand-ink"}`}
          aria-label={tab.label}
          aria-pressed={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        >
          <span className="text-xl leading-none" aria-hidden="true">
            {tab.icon}
          </span>
          <span className="text-[10px] font-medium">{tab.label}</span>
        </Button>
      ))}
    </nav>
  );
}
